import { useEffect, useState } from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import QuoteStatusPill from "../../../components/QuoteStatusPill";
import { QuoteListItem } from "../../../models/Quote";
import { getQuotes } from "../../../services/quoteService";
import { crm } from "./crmTheme";

const brl = (value?: number | null) =>
  value == null ? "—" : value.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

/** Orçamentos do lead (Simulador › Salvar como orçamento), com link para abrir no simulador. */
const ProspectQuotesPanel = ({ prospectId }: { prospectId: string }) => {
  const navigate = useNavigate();
  const [quotes, setQuotes] = useState<QuoteListItem[] | null>(null);

  useEffect(() => {
    let active = true;
    getQuotes({ prospectId }).then((list) => active && setQuotes(list));
    return () => {
      active = false;
    };
  }, [prospectId]);

  return (
    <Box bg={crm.subtle} border={`1px solid ${crm.border}`} borderRadius="10px" p="16px" mb="16px">
      <Text fontSize="sm" fontWeight="700" color={crm.text} mb="12px">
        Orçamentos
      </Text>
      {quotes === null ? (
        <Text fontSize="xs" color={crm.textMuted}>
          Carregando...
        </Text>
      ) : quotes.length === 0 ? (
        <Text fontSize="xs" color={crm.textMuted}>
          Nenhum orçamento para este lead. Salve uma simulação no Simulador vinculando o lead.
        </Text>
      ) : (
        quotes.map((q) => (
          <Flex
            key={q.id}
            align="center"
            justify="space-between"
            gap="8px"
            bg="white"
            border={`1px solid ${crm.border}`}
            borderRadius="8px"
            p="8px 12px"
            mb="6px"
          >
            <Box minW={0}>
              <Text
                as="button"
                fontSize="sm"
                fontWeight="600"
                color={crm.brand}
                onClick={() => navigate(`/simulador?quote=${q.id}`)}
              >
                {q.number}
              </Text>
              <Text fontSize="xs" color={crm.textMuted}>
                v{q.currentVersion} · {brl(q.finalCostBrl)}
              </Text>
            </Box>
            <QuoteStatusPill status={q.status} />
          </Flex>
        ))
      )}
    </Box>
  );
};

export default ProspectQuotesPanel;
